module.exports = __webpack_public_path__ + "img/mobile.74158aa0.webp";